export interface PermissionNode {
  key: string;
  label: string;
  kind: "MENU" | "TAB" | "ACTION";
  parentKey?: string;
  permission?: string;
}

export function descendants(catalog: PermissionNode[], key: string): string[] {
  return [
    key,
    ...catalog
      .filter((node) => node.parentKey === key)
      .flatMap((node) => descendants(catalog, node.key)),
  ];
}

export function toggleNode(
  catalog: PermissionNode[],
  selected: Set<string>,
  key: string,
  checked: boolean,
  grantable: Set<string>,
): Set<string> {
  const next = new Set(selected);
  const branch = descendants(catalog, key);
  if (checked) {
    for (const child of branch) {
      let node = catalog.find((item) => item.key === child);
      const ancestors: string[] = [];
      while (node) {
        ancestors.push(node.key);
        node = catalog.find((item) => item.key === node?.parentKey);
      }
      if (ancestors.every((ancestor) => grantable.has(ancestor)))
        ancestors.forEach((ancestor) => next.add(ancestor));
    }
  } else {
    branch.forEach((child) => next.delete(child));
    // Keep selected ancestors, including a parent with no selected children.
  }
  return next;
}

export function nodeState(
  catalog: PermissionNode[],
  selected: Set<string>,
  key: string,
) {
  const branch = descendants(catalog, key);
  return {
    checked: selected.has(key),
    mixed: selected.has(key) && branch.some((child) => !selected.has(child)),
  };
}
